import React from 'react';
import { Link, withPrefix } from 'gatsby';
import { Breadcrumb, BreadcrumbItem } from '@massds/mayflower-react';
import { slugify } from './index';

export const isInternalLink = (href) => (/^\/.*$/).test(href);
export const prefixInternalLinks = (href) => (isInternalLink(href) ? withPrefix(href) : href);

/* This function takes in two params:
    mainNavDefault is an array of navigation objects to display in the main nav from data/nav/main-nav.json, queried by the mainNav fragment.
    activeIndex is the index of which the current page falls under in the main nav array, this will determine which main nav top category is highlighted as active
  */
// eslint-disable-next-line import/prefer-default-export
export const getMainNavData = (mainNavDefault, activeIndex) => mainNavDefault.map((el, i) => {
  const o = Object.assign({}, el);
  if (i === activeIndex) {
    // add active: true to the active top level main nav item
    o.active = true;
  }
  return o;
});

// eslint-disable-next-line consistent-return
export const getUtilityNavData = (utilNavDefault) => {
  const utilData = [];
  let i = 0;
  const utilNavMaxLength = utilNavDefault.length;
  for (; i < utilNavMaxLength; i += 1) {
    const el = utilNavDefault[i];
    const { altText, ...rest } = el;
    const item = Object.assign({ ariaLabelText: altText }, rest);
    utilData.push(item);
  }
  return utilData;
};


export const getFooterNavData = (footerNavDefault) => footerNavDefault.map((navItem) => {
  const item = Object.assign({}, navItem);
  if (item.links) {
    item.links = normalizeLinks(navItem.links);
  }
  // withPrefix should only be used on internal links.
  return Object.assign({}, item, {
    href: prefixInternalLinks(item.href)
  });
});

// Sets all main navigation links to use site prefix, if any.
export const normalizeLinks = (mainNav) => mainNav.map((navItem) => {
  const item = Object.assign({}, navItem);
  // withPrefix should only be used on internal links.
  return Object.assign({}, item, {
    href: prefixInternalLinks(item.href)
  });
});

export const getBreadCrumb = (items = [], title, dataTimestamp, buildTimestamp) => {
  if (!title) return null;
  const newItems = items.slice();
  newItems.unshift({ href: '/', text: 'Home' });
  // Whether or not the component should render the last updated timestamp.
  const renderTimestamp = parseInt(process.env.RENDER_TIMESTAMP, 10) !== 0;
  return(
    <div className="ma__container">
      {(dataTimestamp || buildTimestamp) && renderTimestamp && (
        <div className="ma__timestamp">
          {dataTimestamp && <p>{`Data Last Updated: ${(new Date(dataTimestamp)).toLocaleString()}`}</p>}
          {buildTimestamp && <p>{`Site Last Generated: ${(new Date(buildTimestamp)).toLocaleString()}`}</p>}
        </div>
      )}
      <Breadcrumb>
        {newItems.length && newItems.map((item, i) => {
          const key = `bread-crumb--${i}`;
          return(<BreadcrumbItem key={key}><Link to={item.href} href={item.href}>{item.text}</Link></BreadcrumbItem>);
        })}
        <BreadcrumbItem currentPage={title} />
      </Breadcrumb>
    </div>
  );
};

/**
 * Creates a breadcrumb object and title.
 *
 * @param {*} data
 *   Object that pulls in the following:
 *     href: starting or base URL. (if /, don't assign a value).
 *     text: starting title. (if Home, don't assign a value to href).
 *     sections: array of section titles. [govshort, secshort, deptshort, etc]
 *
 * @returns {*}
 *   Object which provides data for getBreadcrumb().
 *     pageTitle: string text of the last item in the path array.
 *     breadcrumbprops: array of breadcrumb objects.
 */
export const makeBreadcrumb = (data) => {
  const { sections } = data;
  let { href } = data;
  let breadcrumbprops = [];
  if (href) {
    breadcrumbprops.push({ href, text: data.text });
  }
  if (sections) {
    const sectionCrumbs = sections.filter((section) => section).map((section) => {
      href = href ? `${href}/${slugify(section)}` : `${slugify(section)}`;
      return({
        href,
        text: section
      });
    });
    breadcrumbprops = breadcrumbprops.concat(sectionCrumbs);
  }

  const { text } = breadcrumbprops.pop();
  return{ pageTitle: text, breadcrumbprops };
};


export const toSectionsURL = ({ href, sections }) => {
  const sectionsArray = [];
  const sectionsMax = sections.length;
  let i = 0;
  for (; i < sectionsMax; i += 1) {
    const section = sections[i];
    if (section) {
      sectionsArray.push(slugify(section));
    }
  }
  const sectionsPath = sectionsArray.join('/');
  return`${href}${sectionsPath}`;
};
